// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Bqjc","name":"Header_name__3YVGp","birthday":"Header_birthday__1YIGJ","skeleton":"Header_skeleton__bnKq2"};